const STORAGE_KEY = "hts_advertising_id";

/**
 * Matches a standard UUID v4 format (8-4-4-4-12 hex characters).
 * Used to validate localStorage values before sending to the API.
 */
const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Returns a persistent advertising ID for the current browser.
 * Used by ads-orchestrator to correlate ad requests from the same device
 * across sessions. Stored in localStorage and generated on first access.
 *
 * Values read from localStorage are validated against UUID format before
 * use. Corrupted or non-UUID values are replaced with a fresh UUID.
 */
export const getHtsAdvertisingId = (): string => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored != null && UUID_REGEX.test(stored)) {
      return stored;
    }

    const id = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    // Fallback if localStorage is unavailable (e.g., private browsing, SSR)
    return crypto.randomUUID();
  }
};
